import classNames from 'classnames';
import Image from 'next/image';
import { useTheme } from 'next-themes';

import { ETheme } from '@/enums/theme';

import styles from './Characteristics.module.scss';

const Characteristics = ({ items }) => {
  const { theme } = useTheme();

  const renderIcon = (icon, key) => {
    if (icon.length > 0) {
      return (
        <div
          className={styles.socIcon}
          key={key}
          itemScope
          itemType='https://schema.org/ImageObject'
        >
          <Image
            src={icon}
            alt='social media icon'
            title='Social Media Icon'
            width={56}
            height={56}
            loading='lazy'
          />
        </div>
      );
    }
    return null;
  };

  const renderItem = (item, key) => {
    return (
      <div
        className={`${styles.item} ${styles[items.type]}`}
        key={key}
        itemScope
        itemType='https://schema.org/Article'
      >
        <div className={classNames(['characteristics--image', styles.icon])}>
          <div>
            <Image
              src={
                theme === ETheme.LIGHT_MODE
                  ? item?.light_mode_icon
                  : item?.dark_mode_icon
              }
              alt={item?.text}
              title={item?.text}
              className={theme === ETheme.LIGHT_MODE ? 'white' : ''}
              width={24}
              height={24}
              loading='lazy'
            />
          </div>
          <div className={styles.nameBlock}>
            <span className={styles.name}>{item?.text}</span>

            {item?.tooltip && (
              <span className={styles.tooltip}>
                <span className={styles.tooltipIcon}>
                  <Image
                    src={item?.tooltip_icon}
                    alt={item?.tooltip_icon}
                    title={item?.tooltip_icon}
                    width={42}
                    height={42}
                    loading='lazy'
                  />
                </span>
                <span className={styles.tooltipContent}>{item?.tooltip}</span>
              </span>
            )}
          </div>
        </div>
        <div className={styles.value}>
          {item?.right_text && <>{item?.right_text}</>}
          {item?.right_icons?.length > 0 && (
            <>{item?.right_icons?.map(renderIcon)}</>
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className={styles.characteristics}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <div className={styles.containerTitle}>{items?.title}</div>
      <div className={styles.list}>{items?.sections?.map(renderItem)}</div>
    </div>
  );
};

export default Characteristics;
